














import Vue from "vue";
import { mapState, mapActions } from "vuex";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("appModule", {
      user: "loggedInUser"
    })
  },
  inject: ["actionHandler"],
  methods: {
    handleTableClick() {
      this.actionHandler("add", this.row);
    },
    handleRowItemClick(event: Event) {
      event.stopPropagation();
      this.actionHandler("rowselect", this.row);
    }
  }
});
